

















































import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { UserStatus, UserType } from '@/data/models/user.model';

@Component
export default class FattorinoFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		fname?: string = '';
		lname?: string = '';
		status?: UserStatus = UserStatus.ACTIVE;
	};

	state!: State;

	statusItems: string[] = Object.keys(UserStatus).map(
		// @ts-ignore
		(k: string) => UserStatus[k]
	).filter(s => s != 'idle')

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('user');
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.advancedSearch.addSimpleFilter('utype', UserType.FATTORINO);

		if (this.searchParam.fname) this.advancedSearch.addLikeFilter('fname', this.searchParam.fname);
		if (this.searchParam.lname) this.advancedSearch.addLikeFilter('lname', this.searchParam.lname);
		if (this.searchParam.status) this.advancedSearch.addSimpleFilter('status', this.searchParam.status);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.fname = undefined;
		this.searchParam.lname = undefined;
		this.searchParam.status = UserStatus.ACTIVE;
		this.search();
	}

}
